import React, {Component} from "react";

class SearchActionTd extends Component{
    constructor(props){
        super(props);
    }


    render(){
        return (
            <td>
                <div className="s-add-item">Add</div>
            </td>
        )
    }
}

export default SearchActionTd;


// WEBPACK FOOTER //
// ./src/components/table/SearchTableActionTd.js